import styled from '@emotion/styled';

export const Spacer = styled('div')(() => ({
  minHeight: '10px',
}));
